<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6kraGz/images/9781479803446.jpg?1701092331409" alt="This image is the cover for the book Women in Buddhist Traditions, Women in Religions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Women in Buddhist Traditions, Women in Religions
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A new history of Buddhism that highlights the insights and experiences of women from diverse communities and traditions around the world</b><br/><br/>Buddhist traditions have developed over a period of twenty-five centuries in Asia, and recent decades have seen an unprecedented spread of Buddhism globally. From India to Japan, Sri Lanka to Russia, Buddhist traditions around the world have their own rich and diverse histories, cultures, religious lives, and roles for women.<br/><br/>Wherever Buddhism has taken root, it has interacted with indigenous cultures and existing religious traditions. These traditions have inevitably influenced the ways in which Buddhist ideas and practices have been understood and adapted. Tracing the branches and fruits of these culturally specific transmissions and adaptations is as challenging as it is fascinating.<br/><br/><i>Women in Buddhist Traditions </i>chronicles pivotal moments in the story of Buddhist women, from the beginning of Buddhist history until today. The book highlights the unique contributions of Buddhist women from a variety of backgrounds and the strategies they have developed to challenge patriarchy in the process of creating an enlightened society.<br/><br/><i>Women in Buddhist Traditions</i> offers a groundbreaking and insightful introduction to the lives of Buddhist women worldwide.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karma Lekshe Tsomo
      </h2>
      
      <p class="authorDescription body article">Karma Lekshe Tsomo is Professor of Theology and Religious Studies at the University of San Diego and author of <I>Buddhist Feminism(s) and Femininities</I> and <I>Into the Jaws of Yama, Lord of Death: Buddhism, Bioethics, and Death.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7a5383cd